import React, { useState, useEffect } from "react";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { useHistory } from "react-router-dom";
import { dealerDsrList } from "../../redux/actions/dealerDsrListAction";
import { dealerAddUpdateDsrLimits } from "../../redux/actions/dealerAddUpdateDsrLimitsAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SOLogout from "../../components/Logout/SOLogout";
import SaveIcon from "@mui/icons-material/Save";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Util from "../../validation";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});
const DealerAddNewDsrLimit = () => {
	const [customerId, setCustomerId] = useState("");
	// const navigate = useNavigate();

	const [dsr, setDsr] = useState("");
	const [editCurrency, setEditCurrency] = useState("");

	const [
		addOrUpdateUserWithDrawLimitStatus,
		setaddOrUpdateUserWithDrawLimitStatus
	] = useState(false);

	const [
		addOrUpdateUserWithDrawLimitResArray,
		setaddOrUpdateUserWithDrawLimitResArray
	] = useState("");
	const [setDsrListStatus, setSetDsrListStatus] = useState(false);
	const [setDsrListArray, setSetDsrListArray] = useState([]);

	// const [currency, setCurrency] = useState("");
	const [getDsrNumber, setGetDsrNumber] = useState("");
	// const [getDsrId, setGetDsrId] = useState("");
	const [dsrId, setDsrId] = useState("");
	const [dailyAmountLimit, setDailyAmountLimit] = useState("");
	const [weeklyAmountLimit, setWeeklyAmountLimit] = useState("");
	const [monthlyAmountLimit, setMonthlyAmountLimit] = useState("");
	const [yearlyAmountLimit, setYearlyAmountLimit] = useState("");
	const [addNewWithdrawLimitResArray, setaddNewWithdrawLimitResArray] =
		useState("");
	const [addNewWithdrawLimitStatus, setaddNewWithdrawLimitStatus] =
		useState(false);

	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const handleNoticationClose = () => {
		setNotificationOpen(false);
		history.push('/index/DealerAddLimit')
	};
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const partnerloginUser = useSelector(({ login }) => login);

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const setDsrList = useSelector(({ dealerDsrList }) => dealerDsrList);
	const updateWithdrawLimitRes = useSelector(
		({ dealerAddUpdateDsrLimits }) => dealerAddUpdateDsrLimits
	);

	// const handleClose = () => {
	//     setOpen(false);
	// };
	console.log("adminCurrencyList", adminCurrencyList);
	console.log("adminCurrencyList", adminCurrencyList);
	const addOrUpdateUserWithDrawLimitRes = useSelector(
		({ addOrUpdateUserWithDrawLimit }) => addOrUpdateUserWithDrawLimit
	);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "EditCurrency") {
			// setCurrency(value);
			// setEditCurrency(value);
			setEditCurrency(value == "Select Currency" ? "" : value);
		}
		if (name === "GetDsrId") {
			setDsrId(value == "Select Dsr" ? "" : value);
			// setLevel(value);
		}
		if (name === "GetDsrNumber") {
			setGetDsrNumber(value);
		}

		if (name === "DailyAmountLimit") {
			// setDailyAmountLimit(value);
			Util.verifyAmount(value)
				? setDailyAmountLimit(value)
				: setDailyAmountLimit(dailyAmountLimit);
		}

		if (name === "WeeklyAmountLimit") {
			// setWeeklyAmountLimit(value);
			Util.verifyAmount(value)
				? setWeeklyAmountLimit(value)
				: setWeeklyAmountLimit(weeklyAmountLimit);
		}

		if (name === "MonthlyAmountLimit") {
			// setMonthlyAmountLimit(value);
			Util.verifyAmount(value)
				? setMonthlyAmountLimit(value)
				: setMonthlyAmountLimit(monthlyAmountLimit);
		}

		if (name === "YearlyAmountLimit") {
			// setYearlyAmountLimit(value);
			Util.verifyAmount(value)
				? setYearlyAmountLimit(value)
				: setYearlyAmountLimit(yearlyAmountLimit);
		}
	};

	const DsrListFunc = () => {
		if (setDsrListStatus) {
			if (setDsrList.data.status == "success") {
				setSetDsrListArray([].concat(setDsrList.data.actionList));
			}
			if (setDsrList.data.status == "failed") {
				setSetDsrListArray(setDsrList.data);
				if (
					setDsrList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					setDsrList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};
	const setDsrListReq = () => {
		setSetDsrListStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || ""

				// dealerId:
				// customerId: customerId,
				// currency: currency,

				// dailyLimit: dailyAmountLimit,
				// weeklyLimit: weeklyAmountLimit,
				// monthlyLimit: monthlyAmountLimit,
				// yearlyLimit: yearlyAmountLimit,
				// limitId: "",
			}
		};
		dispatch(dealerDsrList(req, authToken));
	};
	useEffect(() => {
		DsrListFunc();
	}, [setDsrList.data.status]);

	// useEffect(() => {
	//     setDsrListReq()
	// }, [])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setDsrListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const addUserWithDrawLimitFunc = () => {
		setaddNewWithdrawLimitStatus(true);

		const Req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				dsrId: dsrId.split("-")[0],

				dsrNumber: getDsrNumber,
				// dsrNumber: userDsr,
				currency: editCurrency,
				dailyLimit: dailyAmountLimit,
				weeklyLimit: weeklyAmountLimit,
				monthlyLimit: monthlyAmountLimit,
				yearlyLimit: yearlyAmountLimit,
				limitId: ""
			}
		};

		return dispatch(dealerAddUpdateDsrLimits(Req, authToken));
	};
	const addNewWithdrawLimitResFunc = () => {
		if (addNewWithdrawLimitStatus) {
			if (updateWithdrawLimitRes.data.status == "success") {

				setaddNewWithdrawLimitResArray(updateWithdrawLimitRes.data);
				// navigate('');


				setNotificationOpen(true);
				// history.push('/index/DealerAddLimit')
			}
			if (updateWithdrawLimitRes.data.status == "failed") {
				setaddNewWithdrawLimitResArray(updateWithdrawLimitRes.data);
				setNotificationOpen(true);
				//NotificationPopups("error", "Failed", addNewWithdrawLimitRes.data.description);
				if (
					updateWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateWithdrawLimitRes.data.status == "Failed") {
				setaddNewWithdrawLimitResArray(updateWithdrawLimitRes.data);
				setNotificationOpen(true);
				//NotificationPopups("error", "Failed", addNewWithdrawLimitRes.data.description);
				if (
					updateWithdrawLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateWithdrawLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};
	useEffect(() => {
		if (addNewWithdrawLimitStatus) {
			addNewWithdrawLimitResFunc();
		}
	}, [updateWithdrawLimitRes.data.status]);
	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid container>
						<Grid item lg={2} md={2}></Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					{/* <Grid container>
                        <Grid item lg={12} md={12} sm={12}>
                            <h6 align="center" className="text-center">
                                Add Load Limit
                            </h6>
                        </Grid>
                    </Grid> */}
					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									label="Dsr"
									fullWidth={true}
									// name="dsr"
									name="GetDsrId"
									value={dsrId || ""}
									// value={level || ""}
									// defaultValue={"Select Dsr" || dsr}
									onChange={handleChange}
								>
									<MenuItem value="Select Dsr" selected="Select Level">
										Select Dsr
									</MenuItem>
									{setDsrList.success}
									{/* <MenuItem value="BASIC">BASIC</MenuItem> */}
									{setDsrList.success && [].concat(setDsrList.data.actionList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
									{/* setDsrList.data.actionList.map((x) => (
											<MenuItem value={x}>[].concat{x}</MenuItem>
										))} */}
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									label="Currency"
									fullWidth={true}
									name="EditCurrency"
									// value={currency || ""}
									defaultValue={"Select Currency" || editCurrency}
									onChange={handleChange}
								>
									<MenuItem value="Select Currency" selected="Select Currency">
										Select Currency
									</MenuItem>
									<MenuItem value="BDT">BDT</MenuItem>
									{/* {adminCurrencyList.success &&
                                        adminCurrencyList.data.currencyList.map((x) => (
                                            <MenuItem value={x}>{x}</MenuItem>
                                        ))} */}
								</TextField>
							</div>
							{/* <div style={{ marginTop: "1.5rem" }}>
                <TextField
                  type="text"
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="Customer ID"
                  fullWidth={true}
                  name="customerId"
                  value={customerId || ""}
                  onChange={handleChange}
                />
              </div> */}

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Daily Amount Limit"
									fullWidth={true}
									name="DailyAmountLimit"
									value={dailyAmountLimit || ""}
									onChange={handleChange}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Weekly Amount Limit"
									fullWidth={true}
									name="WeeklyAmountLimit"
									value={weeklyAmountLimit || ""}
									onChange={handleChange}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Monthly Amount Limit"
									fullWidth={true}
									name="MonthlyAmountLimit"
									value={monthlyAmountLimit || ""}
									onChange={handleChange}
								></TextField>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									autoFocus={true}
									label="Yearly Amount Limit"
									fullWidth={true}
									name="YearlyAmountLimit"
									value={yearlyAmountLimit || ""}
									onChange={handleChange}
								/>
							</div>

							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								{/* <Button
                                    style={{
                                        // marginLeft: "0.7rem",
                                        backgroundColor: "#00b9f5",
                                        color: "white",
                                    }}
                                    variant="contained"
                                    // color="primary"
                                    onClick={addUserWithDrawLimitFunc}
                                    endIcon={<SaveIcon />}
                                >
                                    Save
                                </Button> */}
								<CustomButton
									style={{
										padding: "8px",
										margin: "0 8px"
									}}
									variant="contained"
									// color="primary"
									onClick={addUserWithDrawLimitFunc}
								>
									Save
									<SaveIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
								</CustomButton>
							</div>
						</Grid>

						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>
			</Layout>
			{addNewWithdrawLimitResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addNewWithdrawLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addNewWithdrawLimitResArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addNewWithdrawLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{addNewWithdrawLimitResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addNewWithdrawLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addNewWithdrawLimitResArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addNewWithdrawLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default DealerAddNewDsrLimit;
